import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Row, Col, Button } from "react-bootstrap";
import "./FiltersBox.scss";
import { Link } from "react-router-dom";
import ContractsSelect from "../ContractsSelect/ContractsSelect";
import ClientCodeSelect from "../ClientCodeSelect/ClientCodeSelect";
import ContractsSelectWithEmptyOption from "../ContractsSelectWithEmptyOption/ContractsSelectWithEmptyOption";
import {
  DatepickerField,
  InputField,
  RadiobuttonsField,
  TextField,
  SelectField,
  StateDrivenSelectInput,
  DateField,
  SimpleSelectField,
} from "../../CaseGenerator/FormFields";
import { useTranslation } from "react-i18next";
import { ManageContainerClass } from "../../../helpers/customHooks";
import i18n from "i18next";

const FiltersBox = (props) => {
  const { t } = useTranslation();
  const {
    config,
    onChange,
    data,
    fromBillsPageAndCondominiumAdminOrMunicipalUser,
    onDataFiltered,
    showBackendFilteredData,
    filter,
    onStartSelected,
    onEndSelected,
    checkContractStatus,
    onReset,
  } = props;
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    setOpened(false);
    // eslint-disable-next-line
  }, [i18n.language]);

  useEffect(() => {
    //console.log("calling");
    if (data && filter) {
      onDataFiltered(filter(data, {}));
    }
    // eslint-disable-next-line
  }, [data]);

  const handleFilterSubmit = (e) => {
    onChange(e);
    if (data) {
      // const test = filter(data, e);
      if (fromBillsPageAndCondominiumAdminOrMunicipalUser) {
        showBackendFilteredData(e, 1);
      } else {
        onDataFiltered(filter(data, e));
      }
    }
  };

  const handleReset = (e) => {
    onReset(e);
  };

  const FilterFormField = (props) => {
    const { type, today, twoYearsAgo, ...otherProps } = props;
    const isUsage = otherProps.usages || false;
    return {
      input: <InputField {...otherProps} />,
      radio: <RadiobuttonsField {...otherProps} />,
      datepicker: (
        <DatepickerField
          {...otherProps}
          setStartDate={onStartSelected}
          setEndDate={onEndSelected}
        />
      ),
      date: (
        <DateField {...otherProps} setToday={today} twoYearsAgo={twoYearsAgo} />
      ),
      text: <TextField {...otherProps} />,
      select: <SelectField {...otherProps} />,
      stateSelect: <StateDrivenSelectInput {...otherProps} />,
      simpleSelect: <SimpleSelectField {...otherProps} />,
      contractDropDown: (
        <>
          <ContractsSelect
            usages={isUsage}
            excludeInactives={checkContractStatus}
            withChooseContractOption={
              fromBillsPageAndCondominiumAdminOrMunicipalUser
            }
            label={otherProps.label}
          />
        </>
      ),
      contractDropDownWithEmptyOption: (
        <>
          <ContractsSelectWithEmptyOption label={otherProps.label} />
        </>
      ),
      clientCodeDropdown: (
        <>
          <ClientCodeSelect label={otherProps.label} />
        </>
      ),
      emptyField: (
        <>
          <div className="emptyField"></div>
        </>
      ),
    }[type];
  };

  const getForm = () => {
    const { fields } = config;
    const initialValues = fields.reduce((accumulator, field) => {
      accumulator[field.name] = field.initialValue || "";
      return accumulator;
    }, {});
    return (
      <Formik
        initialValues={initialValues}
        // validationSchema={currentValidationSchema}
        onSubmit={handleFilterSubmit}
      >
        {({ isSubmitting, errors, touched, submitCount, resetForm }) => (
          <Form id={"filters"}>
            <div className="filter-container">
              <div
                className={
                  fromBillsPageAndCondominiumAdminOrMunicipalUser
                    ? "filter-fields bills-filters-admin-municipal"
                    : "filter-fields"
                }
              >
                <Row>
                  {fields.map((field, fieldIndex) => {
                    // console.log("INITIAL V", field);
                    return (
                      <Col
                        md={field.columnSize}
                        key={field.name}
                        className={
                          field.billNumber ? "col-md-6 input-bill" : null
                        }
                      >
                        {FilterFormField(field)}
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div className="filter-ctas">
                <div className="container-button-submit">
                  <button
                    className="btn btn-secondary button-cancel-filters"
                    onClick={() => {
                      onReset && handleReset();
                      resetForm(initialValues);
                    }}
                    type="button"
                  >
                    {t("filters.buttons.reset")}
                  </button>
                  <button
                    className="btn btn-primary btn-primary--bg-dark-grey-blue filter-cta button-submit-filters"
                    type="submit"
                  >
                    {t("filters.buttons.send")}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  return (
    <div className="gcap-filters font-color-1" data-testid="FiltersBox">
      <div className="gcap-filters--btn-container">
        <div className="container">
          <button
            onClick={(e) => {
              e.preventDefault();
              setOpened(!opened);
            }}
            aria-controls="filter-accordion"
            id="accordion-control"
            className={
              "gcap-filters--btn paragraph-main-fs8" +
              (opened ? " collapsed" : "")
            }
            data-toggle="collapse"
            aria-expanded={opened}
          >
            {t("filters.filters")}{" "}
            {<i className="gc-icon-functional-chevron-down"></i>}
          </button>
        </div>
      </div>
      {opened ? (
        <div className="gcap-filters collapse show" id="filter-accordion">
          <div className="container">
            {opened && (
              <div
                id="filter-accordion"
                role="region"
                aria-labelledby="accordion-control"
              >
                {getForm()}
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

FiltersBox.propTypes = {};

export default FiltersBox;
